import { client } from './client';
import { convertValues } from '~/util';
import {
  ReportingSettlementReport,
  ReportingListSettlementReportResponse,
  ReportingServiceListSettlementReportsParams,
  ReportingServiceScheduleSettlementReportPayload,
} from '~/typings/API';

export type { ReportingSettlementReport };
export type ReportType = 'bank_account_transaction' | 'bank_account_summary' | 'bank_account_monthly_statement';
export type ReportStatus = 'initiated' | 'scheduled' | 'completed' | 'failed';

export class ReportingRepository {
  static async schedule(request: ReportingServiceScheduleSettlementReportPayload) {
    return client
      .post<ReportingServiceScheduleSettlementReportPayload, ReportingSettlementReport>('/reporting', request)
      .then((response) => convertValues<ReportingSettlementReport>(response));
  }

  static async getAll(query?: ReportingServiceListSettlementReportsParams) {
    return client
      .get<ReportingServiceListSettlementReportsParams, ReportingListSettlementReportResponse>('/reporting', { query })
      .then((response) => ({
        reports: Array.isArray(response?.reports)
          ? response.reports.map((e: ReportingSettlementReport) => convertValues<ReportingSettlementReport>(e))
          : [],
        hasMore: Boolean(response?.hasMore),
      }));
  }

  static async get(id: string) {
    return client
      .get<any, ReportingSettlementReport>(`/reporting/${id}`)
      .then((response) => convertValues<ReportingSettlementReport>(response));
  }
}
